import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";
import { CITIES, cityPath } from "@/data/cities";

const IndiaCities = () => (
  <section id="india" className="relative bg-ink border-t border-bone/10 px-6 md:px-12 lg:px-20 py-28 md:py-36" data-testid="india-section">
    <Reveal><Chapter index="07" title="Across India" testid="india-chapter" /></Reveal>
    <div className="mt-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
      <Reveal delay={0.1} className="lg:col-span-5">
        <h2 className="text-4xl sm:text-5xl font-heading font-bold tracking-tight leading-[1.05]" data-testid="india-heading">
          Kota stone, delivered{" "}
          <span className="font-editorial italic font-medium text-copper">across India.</span>
        </h2>
        <p className="mt-6 max-w-md text-sm md:text-base font-light text-bone/60 leading-relaxed">
          Factory-direct from our quarries and units in Kota, Rajasthan, to homes,
          builders and architects in every major city. Pick your city for delivery
          details and a WhatsApp quote with freight.
        </p>
      </Reveal>
      <Reveal delay={0.2} className="lg:col-span-7">
        <ul className="grid grid-cols-1 sm:grid-cols-2 border-t border-bone/15" data-testid="india-city-list">
          {CITIES.map((c) => (
            <li key={c.slug} className="border-b border-bone/15 sm:odd:border-r sm:odd:pr-6 sm:even:pl-6">
              <Link to={cityPath(c)} className="group flex items-center justify-between gap-4 py-4 transition-colors duration-300 hover:text-copper" data-testid={`india-city-${c.slug}`}>
                <span>
                  <span className="font-heading font-bold">Kota Stone in {c.name}</span>
                  <span className="block text-xs text-bone/45 mt-0.5">{c.state}</span>
                </span>
                <ArrowUpRight size={16} className="shrink-0 text-bone/40 transition-[color,transform] duration-300 group-hover:text-copper group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </Link>
            </li>
          ))}
        </ul>
      </Reveal>
    </div>
  </section>
);

export default IndiaCities;
